import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import Contact from "@/pages/Contact";

export const Route = createFileRoute("/_public/contact")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Get a Free Fence Quote in 24 Hours | Modern Fence Install", "Free, no-obligation fence quote. Average response: 3 hours. Call (888) 416-3144 or send a message \u2014 a real fence expert reviews every inquiry.", "/contact", false),
  component: Contact,
});
